/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAddReferenceableAndCopySubscribers} from '../api'

export const useMutationBulkAddReferenceableAndCopySubscribers = createReactQueryMutationHook('bulkAddReferenceableAndCopySubscribers', bulkAddReferenceableAndCopySubscribers)
